export const HealthArticle = {
  VirtualListItem: 'virtual-list-item',
  SeeMoreBtn: 'see-more-btn',
} as const;
